import { Api } from "@ptx-autonomous/libs/flightpath-service-api";
import { computed, type Ref } from "vue";
import { useFarmListQuery } from "./farms";
import type { SingleMachineField } from "../types";

export function useFields(
	flightPathServiceHttp: Api<unknown>,
	allowNonRtkRecordedBoundaries: Ref<boolean>,
) {
	const farmsQuery = useFarmListQuery(
		flightPathServiceHttp,
		allowNonRtkRecordedBoundaries,
	);
	const farms = computed(() => {
		return (farmsQuery.data.value ?? []).filter(farm => farm.boundary);
	});

	const fields = computed<SingleMachineField[]>(() => {
		const farmsPolygons: SingleMachineField[] = farms.value.map(farm => {
			return {
				farmId: farm.id,
				fieldId: farm.boundary.id,
				innerFieldId: farm.innerBoundary?.id,
				fieldName: farm.name,
				fieldBoundary: farm.boundary.geometry,
				innerBoundary: farm.innerBoundary?.geometry,
				zones: farm.zones ?? [],
			};
		});

		return farmsPolygons.sort((a, b) =>
			a.fieldName.localeCompare(b.fieldName),
		);
	});

	return {
		data: fields,
		isLoading: farmsQuery.isLoading,
		refetch: farmsQuery.refetch,
	};
}
